import { render } from "./ThemeWrapper.vue?vue&type=template&id=f7dbf1e4"
import script from "./ThemeWrapper.vue?vue&type=script&lang=js"
export * from "./ThemeWrapper.vue?vue&type=script&lang=js"

import "@/assets/severny-theme/scss/style.scss?vue&type=style&index=0&lang=scss"
import "./ThemeWrapper.vue?vue&type=style&index=1&id=f7dbf1e4&lang=css"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__